import { BasicButton, PrimaryButton, TextButton } from '../../widgets/buttons';
import { Input } from '../../widgets/input';
import React from 'react';
import { Section } from 'src/components/widgets/section';
import styled from 'styled-components';

export const NameAndEMailContainerMyAccount = styled.div`
    display: grid;
    gap: 24px;
    padding-top: 20px;
    padding-bottom: 24px;
`;

export const NameContainer = styled.div`
    display: grid;
    gap: 8px;
`;

export const FieldsContainer = styled.div`
    padding-top: 10px;
    display: grid;
    gap: 6px;
`;

export const TwoFieldsOneRow = styled.div`
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 25px;
    label {
        line-height: 15px;
    }
`;

export const FieldBlock = styled.div`
    display: grid;
    gap: 10px;
    padding-top: 10px;
    input {
        color: black;
    }
`;

export const HalfBlock = styled.div`
    width: 50%;
    display: grid;
    label {
        line-height: 15px;
    }
`;

export const ButtonRightBlock = styled.div`
    button {
        float: right;
    }
`;

// width: ${props => props.hasTwoButtons ? 'auto' : '100%'};   <{hasTwoButtons?: boolean}>
export const ButtonsBlock = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: auto 1fr auto;

    margin-left: auto;
    margin-right: 0;
    margin-top: 20px;
    margin-bottom: 10px;

    button {
        margin-left: 20px;
        float: right;
    }
    div {
        &:hover {
            cursor: pointer;
        }
    }
`;

export const Button1 = styled.div`
    grid-column: 1;
    display: flex;
    align-items: center;
`;

export const Button2 = styled.div`
    grid-column: 2;
    justify-self: end;
`;

export const Button3 = styled.div`
    grid-column: 3;
    justify-self: start;
`;

interface DinamicPrimaryButtonProps {
    isPrimaryButton: boolean;
    onClick: () => void;
    textButton: string;
}

export const DinamicPrimaryButton: React.FC<DinamicPrimaryButtonProps> = ({ isPrimaryButton, onClick, textButton }) => {
    return (
        <div>{isPrimaryButton ? <PrimaryButton onClick={onClick}>{textButton}</PrimaryButton> : <BasicButton onClick={onClick}>{textButton}</BasicButton>}</div>
    );
};

export const SectionDelete = styled(Section)`
    padding-top: 10px;
    padding-bottom: 20px;
    div:first-child {
        display: grid;
        gap: 10px;
        grid-template-columns: auto;
        grid-template-rows: 50px auto auto 30px;
        place-items: center;
        padding-top: 15px;
        padding-bottom: 10px;
    }
`;

export const DeleteAccountShopify = styled.div`
    display: inline;
    label {
        font-size: 14px;
    }
`;

export const TextButtonDelete = styled(TextButton)`
    &:hover {
        cursor: pointer;
    }
`;

export const InputPassword = styled(Input)`
    color: black;
    font-size: 11px;
`;
